import { useMemo } from 'react'
import { useSeenWatermark } from './useSeenWatermark'
import type { SetPost } from '../types'

/**
 * Unread count for the event page's Crew pill: peer posts created since the
 * last time this user had the Crew tab open. Own posts never count.
 *
 * The watermark is per event, in `users/{uid}/private/crewSeen`'s eventId →
 * epoch-millis map. Anonymous guests own their private doc too, so they get the
 * same behaviour as signed-in users.
 */
export function useCrewUnread(
  eventId: string,
  userId: string | null,
  posts: SetPost[],
  active: boolean,
): number {
  const times = useMemo(
    () => posts.filter(p => p.authorId !== userId).map(p => p.createdAt?.toMillis?.() ?? 0),
    [posts, userId],
  )
  return useSeenWatermark({ uid: userId, docName: 'crewSeen', key: eventId, times, active, logTag: 'crew' }).unread
}
